import { Input, Form } from "antd";
import { useEffect, useState } from "react";
import CannedOrderListing from "./CannedOrderListing";
import CannedOrderDetails from "./CannedOrderDetails";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import { paginationLimit } from "../../utils/helper/constants";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import toast from "react-hot-toast";

const { Search } = Input;

const CannedOrderListDetail = ({ activeTab, getStatusCounts }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState({ ...paginationLimit, limit: 20 });
  const [orderDetailId, setOrderDetailId] = useState(0);
  const [orderDetailData, setOrderDetailData] = useState(null);
  const [search, setSearch] = useState("");

  const getAllCannedOrders = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        status: activeTab,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
        search: search,
      };
      let response = await globalRequest(
        Apis.MANAGE_CANNED_ORDER.GET_ALL_ORDER_LIST,
        "get",
        {},
        { params: params },
        true
      );
      if (response?.status === 200) {
        const data = response?.data?.data?.data || [];
        setList(data);
        if (data.length > 0 && orderDetailId === 0) {
          setOrderDetailId(data[0].id);
        } else if (data.length === 0) {
          setOrderDetailId(0);
          setOrderDetailData(null);
        }
        getStatusCounts(); // Refresh counts
      }
    } catch (e) {
      toast.error(e?.message || "Failed to fetch orders");
    }
    dispatch(changeLoader(false));
  };

  const getOrderDetails = async () => {
    if (!orderDetailId) return;
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        `${Apis.MANAGE_CANNED_ORDER.GET_ORDER_DETAIL}/${orderDetailId}`,
        "get",
        {},
        {},
        true
      );
      if (response?.status === 200) {
        setOrderDetailData(response?.data?.data);
      }
    } catch (e) {
      toast.error(e?.message || "Failed to fetch details");
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      getAllCannedOrders();
    }, 400);
    return () => clearTimeout(timer);
  }, [activeTab, paginationModel.page, search]);

  useEffect(() => {
    if (orderDetailId) {
      getOrderDetails();
    }
  }, [orderDetailId]);

  const handleParentScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      // Infinite scroll logic can be added here if needed
    }
  };

  return (
    <div className="flex bg-white">
      {/* Left Sidebar List */}
      <div className="w-[320px] min-w-[320px] border-r border-gray-200">
        <div className="p-4 border-b border-gray-200">
          <Form form={form} autoComplete="off">
            <Form.Item name="search" className="mb-0">
              <Search
                placeholder="Search by Order # or Tx ID"
                allowClear
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length >= 3 || value.length === 0) {
                    setSearch(value);
                    setPaginationModel(prev => ({ ...prev, page: 1 }));
                  }
                }}
              />
            </Form.Item>
          </Form>
        </div>
        <div className="overflow-y-auto h-[881px]" onScroll={handleParentScroll}>
          <CannedOrderListing 
            handleOrderDetail={setOrderDetailId} 
            list={list} 
            selectedId={orderDetailId}
          />
        </div>
      </div>

      {/* Right Detail View */}
      <div className="flex-1">
        <CannedOrderDetails 
          orderDetailId={orderDetailId} 
          orderDetailData={orderDetailData} 
          reloadPage={() => {
            getAllCannedOrders();
            getOrderDetails();
          }}
        />
      </div>
    </div>
  );
};

export default CannedOrderListDetail;
